import { render, staticRenderFns } from "./TipCategories.vue?vue&type=template&id=c9e036c0"
import script from "./TipCategories.vue?vue&type=script&lang=js"
export * from "./TipCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports